import axios from 'axios'
import {
  get,
  post,
  del,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'

// 医药费二次报销列表
export function getWarmReimbursementList(params) {
  return get(`${HOST}warm-oneself-reimbursement-/pcPage`, params)
}
// 获取部门/单位列表
export function getOrganizationList(params) {
  return get(`${HOST}organization-info/treeList/`, params)
}
// 查询用户 
export function getUserList(params) {
  return get(`${HOST}sys-user/list`, params)
}
// 报销详情
export function getReimbursementDetails(params) {
  return get(`${HOST}warm-oneself-reimbursement-/pcGetById`, params)
}
// 根据id修改
export function warmOneselfReimbursementUpdate(params) {
  return post(`${HOST}warm-oneself-reimbursement-/update`, params)
}
// 添加
export function warmOneselfReimbursementSave(params) {
  return post(`${HOST}warm-oneself-reimbursement-/save`, params)
}
// 导出
export function warmOneselfReimbursementExport(params) {
  return getfile(`${HOST}warm-oneself-reimbursement-/export`, params)
}
// 根据id删除
export function warmOneselfReimbursementDelete(params) {
  return del(`${HOST}warm-oneself-reimbursement-/delete`, params)
}
// 供暖费发票查看更多
export function getWarmOneselfReimbursementList(params) {
  return get(`${HOST}warm-oneself-reimbursement-/getWarmOneselfReimbursementList`,params)
}


// WEBPACK FOOTER //
// ./src/views/HeatingFee/api/api.js